<template>
  <div>
    <div id="header-wrapper">
			<div class="header">
				<h1>Iconography</h1>
			</div>
		</div>
    <!--Content-->
		<div id="content">
      <h2>UI icon</h2>
      <div class="ui-icon" v-for="icon in uiIcons" :key="icon.name">
        <div class="box mt--bg--neutrals-light-gray-01"><mt-icon :iconName="icon.name" :width="icon.width" /></div>
        <div class="name">{{icon.name}}</div>
      </div>
      <div class="mt--clearfix"></div>

      <h2>Pictogram</h2>
      <div class="ui-icon" v-for="icon in pictograms" :key="icon.name">
        <div class="box mt--bg--neutrals-light-gray-01"><mt-icon :iconName="icon.name" :width="icon.width" /></div>
        <div class="name">{{icon.name}}</div>
      </div>
      <div class="mt--clearfix"></div>

      <h2>Channel icon</h2>
      <div class="ui-icon" v-for="icon in channelIcons" :key="icon.name">
        <div class="box mt--bg--neutrals-light-gray-01">
          <i :class="`mt-channel-icon mt-channel-icon--${icon.value}-initial`"></i>
        </div>
        <div class="name">{{icon.name}}</div>
      </div>
      <div class="mt--clearfix"></div>

      <div class="ui-icon" v-for="icon in channelIcons" :key="icon.name">
        <div class="box mt--bg--neutrals-light-gray-01">
          <i :class="`mt-channel-icon mt-channel-icon--${icon.value}-initial-disable`"></i>
        </div>
        <div class="name">{{icon.name}}</div>
      </div>
      <div class="mt--clearfix"></div>

      <h2>Channel logo</h2>
      <div class="ui-icon logo" v-for="icon in channelIcons" :key="icon.name">
        <div class="box mt--bg--neutrals-light-gray-01">
          <i :class="`mt-channel-icon mt-channel-icon--${icon.value}`"></i>
        </div>
        <div class="name">{{icon.name}}</div>
      </div>
      <div class="mt--clearfix"></div>

      <div class="ui-icon logo" v-for="icon in channelIcons" :key="icon.name">
        <div class="box mt--bg--neutrals-light-gray-01">
          <i :class="`mt-channel-icon mt-channel-icon--${icon.value}-disable`"></i>
        </div>
        <div class="name">{{icon.name}}</div>
      </div>
		</div>
    <!--//Content-->
  </div>
</template>
<script>
export default {
  name: 'iconography-page',
  data() {
    return {
      uiIcons: [
        {name: 'dashboard',  },
        {name: 'reports',  },
        {name: 'graph-line-thick',  },
        {name: 'graph-bar-thick',  },
        {name: 'settings',  },
        {name: 'graph-line-thin',  },
        {name: 'graph-bar-thin',  },
        {name: 'graph-scatter-thin',  },
        {name: 'graph-sm-line-thin',  },
        {name: 'graph-sm-bar-thin',  },
        {name: 'chevron-left', },
        {name: 'chevron-right', },
        {name: 'chevron-up',  },
        {name: 'chevron-down',  },
        {name: 'plus',  },
        {name: 'minus',  },
        {name: 'close',  },
        {name: 'filter',  },
        {name: 'download',  },
        {name: 'upload',  },
        {name: 'more', },
        {name: 'delete',  },
        {name: 'search',  },
        {name: 'edit',  },
        {name: 'reset',  },
        {name: 'eye',  },
        {name: 'loading',  },
        {name: 'loading2',  },
        {name: 'check',  },
        {name: 'sync',  },
        {name: 'close-circle',  },
        {name: 'help-circle',  },
        {name: 'information-circle',  },
        {name: 'error-circle',  },
        {name: 'warning-circle',  },
        {name: 'check-circle',  },
        {name: 'arrow-left',  },
        {name: 'arrow-right',  },
        {name: 'arrow-up',  },
        {name: 'arrow-down',  },
        {name: 'ascending-sort',  },
        {name: 'descending-sort',  },
        {name: 'user',  },
        {name: 'link',  },
        {name: 'list',  },
        {name: 'save',  },
        {name: 'folder',  },
        {name: 'enter',  },
        {name: 'calendar',  },
      ],
      pictograms: [
        {name: 'pictogram-01',},
        {name: 'pictogram-02',},
        {name: 'pictogram-03',},
      ],
      channelIcons: [
        {name: 'naver', value: 'naver' },
        {name: 'facebook', value: 'facebook' },
        {name: 'instagram', value: 'instagram' },
        {name: 'daumclix', value: 'daumclix' },
        {name: 'google_youtube', value: 'google_youtube' },
        {name: 'google_display', value: 'google_display' },
        {name: 'google_adwords', value: 'google_search'},
        {name: 'google_analytics', value: 'google_analytics'},
        {name: 'targeting_gates', value: 'targeting_gates'},
        {name: 'mobon', value: 'mobon'},
        // {name: 'user', value: 'user'},
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../plugins/mtui/styles/Variables.scss";
.ui-icon {
  float: left;
  margin-right: 15px;
  margin-bottom: 12px;
  .name {
    padding-top: 20px;
    width: 119px;
    height: 40px;
    font-size: 14px;
  }
}
.box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 119px;
  height: 119px;
}
.logo .box { width: 143px; }
</style>



// WEBPACK FOOTER //
// Iconography.vue?7930d1b7